import { useGetContactsListQuery } from "components/contacts-table/endpoints";
import {
  useGetScanResultQuery,
  useGetScanjobQuery,
} from "pages/draft-overview/endpoints";
import { GaiaConstants } from "utils";

interface UseLoadDataParams {
  shortId?: string;
  mode: "create" | "draft";
  teamName: string;
}

/**
 * Custom hook to load all necessary data for the Create Audit Form
 * Consolidates scan result, scan job, and contacts data loading
 */
export const useLoadData = ({ shortId, mode, teamName }: UseLoadDataParams) => {
  // Load scan result data for draft mode
  const { data: scanResultData, isLoading: isLoadingScanResult } =
    useGetScanResultQuery(
      { shortId: shortId! },
      { refetchOnMountOrArgChange: true, skip: mode !== "draft" || !shortId }
    );

  // Load scan job data for draft mode
  const { data: scanJobData, isLoading: isLoadingScanJob } = useGetScanjobQuery(
    { shortId: shortId! },
    { refetchOnMountOrArgChange: true, skip: mode !== "draft" || !shortId }
  );

  // Load contacts list
  const { data: contactsList, isLoading: isLoadingContacts } =
    useGetContactsListQuery(
      { teamName: teamName },
      {
        refetchOnFocus: true,
        skip: !teamName || teamName === GaiaConstants.PLACE_HOLDER,
      }
    );

  const isLoading =
    isLoadingScanResult || isLoadingScanJob || isLoadingContacts;

  return {
    scanResultData,
    scanJobData,
    contactsList,
    isLoading,
  };
};
